import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from "@angular/core";
import {UntypedFormBuilder, UntypedFormControl, Validators} from "@angular/forms";
import {PreguntaModelDTO} from "@Models";
import {Subscription} from "rxjs";
import {Debounce} from "@shared/decoradores";
import {NotificacionServiceEmisor} from "@shared/services";
import {TiposPreguntasService} from "../../tipos-preguntas.service";
import {TipoPreguntaComponent} from "../tipo-pregunta/tipo-pregunta.component";


@Component({
    selector: "app-tipo-pregunta-rango",
    templateUrl: "./tipo-pregunta-rango.component.html",
    styleUrls: ["./tipo-pregunta-rango.component.scss"]
})
export class TipoPreguntaRangoComponent extends TipoPreguntaComponent implements OnInit, OnDestroy, OnChanges {
    public pregunta: PreguntaModelDTO;
    public valores: number[] = [];
    public opcionesControl = new UntypedFormControl(1);
    public formGroupRangoOpciones = this.formBuilder.group({
        desde: [0, Validators.required],
        hasta: [1, Validators.required],
        opciones: [2, Validators.required]
    });
    public formGroupRangoIncremento = this.formBuilder.group({
        desde: [0, Validators.required],
        hasta: [1, Validators.required],
        incremento: [1, Validators.required]
    });

    private subs = new Subscription();

    constructor(private tiposPreguntasService: TiposPreguntasService, private formBuilder: UntypedFormBuilder,
        private notificacionService: NotificacionServiceEmisor) {
        super();
    }

    public ngOnInit(): void {
        this.pregunta = this.tiposPreguntasService.preguntaModel;
        const maximo = this.pregunta.Maximo ?? 1;
        const minimo = this.pregunta.Minimo ?? 0;
        const paso = this.pregunta.Paso ?? 1;
        this.opcionesControl.setValue(((maximo - minimo) / paso) + 1);

        this.subs.add(
            this.formGroupRangoOpciones.valueChanges.subscribe(() => this.recalcularIncremento())
        );
        this.subs.add(
            this.formGroupRangoIncremento.valueChanges.subscribe(() => this.recalcularOpciones())
        );
        this.formGroupRangoOpciones.setValue({
            desde: minimo,
            hasta: maximo,
            opciones: (maximo - minimo + paso) / paso
        }, { emitEvent: false });
        this.formGroupRangoIncremento.setValue({
            desde: minimo,
            hasta: maximo,
            incremento: this.pregunta.Paso
        }, { emitEvent: false });
    }

    public ngOnChanges(changes: SimpleChanges) {
        if (changes.accesoPublico != null && changes.accesoPublico.currentValue != null) {
            if (changes.accesoPublico.currentValue) {
                this.formGroupRangoIncremento.disable();
                this.formGroupRangoOpciones.disable();
            }
        }
    }

    public ngOnDestroy(): void {
        this.subs.unsubscribe();
    }

    private recalcularOpciones() {
        const valores = this.formGroupRangoIncremento.value;
        const opciones = (valores.hasta - valores.desde + valores.incremento) / valores.incremento;
        this.formGroupRangoOpciones.setValue({
            hasta: valores.hasta,
            desde: valores.desde,
            opciones
        }, {  emitEvent: false });
        this.cargarEnPregunta();
    }

    private recalcularIncremento() {
        const valores = this.formGroupRangoOpciones.value;
        const incremento = (valores.hasta - valores.desde) / (valores.opciones - 1);
        this.formGroupRangoIncremento.setValue({
            hasta: valores.hasta,
            desde: valores.desde,
            incremento
        }, { emitEvent: false });
        this.cargarEnPregunta();
    }

    @Debounce(500)
    private cargarEnPregunta() {
        if (this.formGroupRangoIncremento.value.incremento % 1 !== 0 ||
            this.formGroupRangoOpciones.value.opciones % 1 !== 0) {
            this.notificacionService.notificarError("El incremento y las opciones tienen que ser enteros");
            return;
        }
        const valores = this.formGroupRangoIncremento.value;
        this.pregunta.Minimo = valores.desde;
        this.pregunta.Maximo = valores.hasta;
        this.pregunta.Paso = valores.incremento;
        this.valores = [];

        for (let i = 0; i < this.formGroupRangoOpciones.value.opciones; i++) {
            this.valores.push(valores.desde + valores.incremento * i);
        }
    }
}
